/*!
 * Professor Pure - Pure Supply Shop storefront embed (template mode v1)
 * LLM-capable: tries CONFIG.chatApiUrl /chat first, falls back to localChat templates. No API keys in the browser.
 */
(function () {
  'use strict';

  /* ========== Bundled catalog ========== */
  var PP_CATALOG = [{"title":"Truly Beauty Coco Cloud Luxury Shave Butter","handle":"truly-beauty-coco-cloud-luxury-shave-butter","url":"https://puresupplyshop.com/products/truly-beauty-coco-cloud-luxury-shave-butter","productType":"","vendor":"Truly Beauty","tags":["Bodycare","Coco Cloud","Coconut","Shave Butter","Shave Cream","Truly Beauty","Vegan Beauty"],"collections":["Beauty","Bodycare"],"descriptionSnippet":"Transform your shaving routine with Truly Beauty Coco Cloud Luxury Shave Butter, a rich, whipped shaving cream designed to soften skin and hair for a smooth, comfortable, ultra-close shave.","available":false},{"title":"Truly Beauty Glazed Donut Shave Butter","handle":"truly-beauty-glazed-donut-shave-butter","url":"https://puresupplyshop.com/products/truly-beauty-glazed-donut-shave-butter","productType":"","vendor":"Truly Beauty","tags":["Bodycare","Shave Butter"],"collections":["Beauty","Bodycare"],"descriptionSnippet":"Upgrade your shaving routine with Truly Beauty Glazed Donut Luxury Shave Butter, a rich, whipped shaving butter designed to help deliver a smooth, comfortable shave while leaving skin feeling soft and moisturized.","available":true},{"title":"Vanicream Shave Cream 6 oz","handle":"vanicream-shave-cream-6oz","url":"https://puresupplyshop.com/products/vanicream-shave-cream-6oz","productType":"","vendor":"Vanicream","tags":["Bodycare"],"collections":["Beauty","Bodycare"],"descriptionSnippet":"Get a smooth, close, and comfortable shave with Vanicream Shave Cream, a gentle, non-lathering shaving cream specially formulated for sensitive and easily irritated skin.","available":false},{"title":"Hume Health Body Pod Smart Scale","handle":"hume-health-body-pod-smart-scale","url":"https://puresupplyshop.com/products/hume-health-body-pod-smart-scale","productType":"","vendor":"Hume Health","tags":["Device","Fitness Tracker"],"collections":["Wellness","Smart Health & Fitness Devices"],"descriptionSnippet":"Go beyond body weight with the Hume Health Body Pod, an advanced smart body composition scale designed to give you a more complete picture of health, fitness, and physical progress from home.","available":true},{"title":"Viviscal PRO Professional Strength Dietary Supplement - 60ct Tablets","handle":"viviscal-pro-professional-strength-dietary-supplement-60ct","url":"https://puresupplyshop.com/products/viviscal-pro-professional-strength-dietary-supplement-60ct","productType":"Vitamins & Dietary Supplements","vendor":"Viviscal","tags":["Dietary Supplement","Haircare","Supplement","Vitamins","Viviscal"],"collections":["Health","Beauty","Haircare"],"descriptionSnippet":"Viviscal PRO Professional Strength is a dietary supplement with AminoMar Marine Complex, biotin, vitamin C, apple fruit extract, L-Cystine, and L-Methionine for daily nutritional support.","available":false},{"title":"Vanicream Shampoo for Sensitive Skin","handle":"vanicream-shampoo-for-sensitive-skin","url":"https://puresupplyshop.com/products/vanicream-shampoo-for-sensitive-skin","productType":"","vendor":"Vanicream","tags":["Hair Care","Shampoo"],"collections":["Haircare"],"descriptionSnippet":"Give sensitive hair and scalp a gentle, effective cleanse with Vanicream Shampoo, a fragrance-free shampoo specifically formulated for people with sensitive skin.","available":false},{"title":"Vanicream Conditioner for Sensitive Skin","handle":"vanicream-conditioner-for-sensitive-skin","url":"https://puresupplyshop.com/products/vanicream-conditioner-for-sensitive-skin","productType":"","vendor":"Vanicream","tags":["Conditioner","Hair Care"],"collections":["Haircare"],"descriptionSnippet":"Keep hair feeling soft, manageable, and healthy with Vanicream Conditioner, a gentle fragrance-free conditioner formulated for sensitive skin and scalps.","available":false},{"title":"Vanicream Liquid Cleanser 8 fl oz","handle":"vanicream-liquid-cleanser-8-fl-oz","url":"https://puresupplyshop.com/products/vanicream-liquid-cleanser-8-fl-oz","productType":"","vendor":"Vanicream","tags":["Cleanser"],"collections":["Beauty","Facial Cleansers"],"descriptionSnippet":"Cleanse without the harsh after-feel using Vanicream Liquid Cleanser, a gentle, non-foaming wash specially formulated for sensitive and dry skin.","available":false},{"title":"Vanicream Hair Styling Gel 7 oz","handle":"vanicream-hair-styling-gel-7-oz","url":"https://puresupplyshop.com/products/vanicream-hair-styling-gel-7-oz","productType":"","vendor":"Vanicream","tags":["Haircare"],"collections":["Beauty","Haircare"],"descriptionSnippet":"Style with a lighter touch using Vanicream Hair Styling Gel, a fragrance-free gel formulated with sensitive scalps in mind for flexible hold and definition.","available":false},{"title":"Vanicream Moisturizing Cream 1 lb Jar","handle":"vanicream-moisturizing-cream-1-lb","url":"https://puresupplyshop.com/products/vanicream-moisturizing-cream-1-lb","productType":"","vendor":"Vanicream","tags":["Moisturizer"],"collections":["Beauty","Lotions & Moisturizers"],"descriptionSnippet":"Deeply moisturize dry, sensitive skin with Vanicream Moisturizing Cream, a rich, non-greasy cream in the classic 1 lb screw-top jar without a pump.","available":false},{"title":"Vanicream Moisturizing Cream 2 oz","handle":"vanicream-moisturizing-cream-2-oz","url":"https://puresupplyshop.com/products/vanicream-moisturizing-cream-2-oz","productType":"","vendor":"Vanicream","tags":["Moisturizer"],"collections":["Beauty","Lotions & Moisturizers"],"descriptionSnippet":"Take sensitive-skin moisture anywhere with Vanicream Moisturizing Cream in a convenient 2 oz, travel-friendly tube for dry or sensitive skin.","available":false},{"title":"Vanicream Moisturizing Cream 1 lb - Includes Pump","handle":"vanicream-moisturizing-cream-1-lb-1","url":"https://puresupplyshop.com/products/vanicream-moisturizing-cream-1-lb-1","productType":"","vendor":"Vanicream","tags":["Moisturizer"],"collections":["Beauty","Lotions & Moisturizers"],"descriptionSnippet":"Get the same rich Vanicream Moisturizing Cream in a 1 lb jar with pump dispenser, handy for mess-free dispensing on dry, sensitive skin.","available":false},{"title":"Vanicream Deodorant 2 oz","handle":"vanicream-deodorant-2-oz","url":"https://puresupplyshop.com/products/vanicream-deodorant-2-oz","productType":"","vendor":"Vanicream","tags":["Bodycare"],"collections":["Beauty","Bodycare"],"descriptionSnippet":"Refresh your underarm routine with Vanicream Deodorant, formulated for sensitive underarms without aluminum, dyes, or fragrance.","available":false},{"title":"Vanicream Moisturizing Lotion 16 oz","handle":"vanicream-moisturizing-lotion-16-oz","url":"https://puresupplyshop.com/products/vanicream-moisturizing-lotion-16-oz","productType":"","vendor":"Vanicream","tags":["Lotion"],"collections":["Beauty","Lotions & Moisturizers"],"descriptionSnippet":"Moisturize with a lighter touch using Vanicream Moisturizing Lotion, a daily lotion for sensitive skin in a 16 oz bottle for full-body use.","available":false},{"title":"Vanicream Cleansing Bar 3.9 oz","handle":"vanicream-cleansing-bar-3-9-oz","url":"https://puresupplyshop.com/products/vanicream-cleansing-bar-3-9-oz","productType":"","vendor":"Vanicream","tags":["Bodycare"],"collections":["Beauty","Bodycare"],"descriptionSnippet":"Wash with a milder solid cleanser using the Vanicream Cleansing Bar, a gentle, soap-free bar for sensitive skin on face or body.","available":true},{"title":"Vanicream Gentle Facial Cleanser 8 fl oz","handle":"vanicream-gentle-facial-cleanser-8-fl-oz","url":"https://puresupplyshop.com/products/vanicream-gentle-facial-cleanser-8-fl-oz","productType":"","vendor":"Vanicream","tags":["Face Wash"],"collections":["Facial Cleansers"],"descriptionSnippet":"Start and end your day with Vanicream Gentle Facial Cleanser, a mild face wash made for sensitive facial skin.","available":false},{"title":"Vanicream Facial Moisturizer SPF30 2.5 oz","handle":"vanicream-facial-moisturizer-spf30-2-5-oz","url":"https://puresupplyshop.com/products/vanicream-facial-moisturizer-spf30-2-5-oz","productType":"","vendor":"Vanicream","tags":["Sunscreen"],"collections":["Beauty","Sunscreen & Sun Care"],"descriptionSnippet":"Simplify daytime care with Vanicream Facial Moisturizer SPF 30, combining lightweight moisture and broad-spectrum SPF 30 for sensitive face skin.","available":false},{"title":"Truly Beauty Smooth Legend After Shave Serum","handle":"truly-beauty-smooth-legend-after-shave-serum","url":"https://puresupplyshop.com/products/truly-beauty-smooth-legend-after-shave-serum","productType":"","vendor":"Truly Beauty","tags":["After Shave Serum","AHA","Body Serum","Bodycare","KP appearance","Post Shave","Skincare","Smooth Legend","Truly Beauty","Vegan Beauty"],"collections":["Beauty","Skincare","Bodycare"],"descriptionSnippet":"Shop Truly Beauty Smooth Legend After Shave Serum, a lightweight resurfacing body serum for post-shave skin that looks rough, bumpy, or uneven.","available":false},{"title":"Truly Beauty Coco Cloud After Shave Serum","handle":"truly-beauty-coco-cloud-after-shave-serum","url":"https://puresupplyshop.com/products/truly-beauty-coco-cloud-after-shave-serum","productType":"","vendor":"Truly Beauty","tags":["After Shave Serum","Body Serum","Bodycare","Coco Cloud","Coconut","Post Shave","Sensitive Skin Feel","Truly Beauty","Vegan Beauty"],"collections":["Beauty","Skincare","Bodycare"],"descriptionSnippet":"Cool down your shave routine with Truly Beauty Coco Cloud After Shave Serum, a milky, lightweight post-shave serum with coconut milk and argan oil.","available":false},{"title":"Truly Beauty Glazed Donut After Shave Oil","handle":"truly-beauty-glazed-donut-after-shave-oil","url":"https://puresupplyshop.com/products/truly-beauty-glazed-donut-after-shave-oil","productType":"","vendor":"Truly Beauty","tags":["After Shave Oil","Body Oil","Bodycare","Glazed Donut","Hyaluronic Acid","Niacinamide","Post Shave","Truly Beauty","Vanilla","Vegan Beauty"],"collections":["Beauty","Skincare","Bodycare"],"descriptionSnippet":"Get a glazed, soft-focus finish with Truly Beauty Glazed Donut After Shave Oil, a silky, fast-absorbing body oil for post-shave dryness and dull-looking skin.","available":false},{"title":"Truly Beauty Soft Serve After Shave Oil","handle":"truly-beauty-soft-serve-after-shave-oil","url":"https://puresupplyshop.com/products/truly-beauty-soft-serve-after-shave-oil","productType":"","vendor":"Truly Beauty","tags":["After Shave Oil","Body Oil","Bodycare","Brightening Appearance","Jojoba","Post Shave","Soft Serve","Truly Beauty","Vegan Beauty"],"collections":["Beauty","Skincare","Bodycare"],"descriptionSnippet":"Shop Truly Beauty Soft Serve After Shave Oil, a silky after-shave oil with strawberry extract, hyaluronic acid, jojoba, and vanilla oil.","available":false},{"title":"Truly Beauty Vanilla Baby Luxury Body Oil","handle":"truly-beauty-vanilla-baby-luxury-body-oil","url":"https://puresupplyshop.com/products/truly-beauty-vanilla-baby-luxury-body-oil","productType":"","vendor":"Truly Beauty","tags":["Bakuchiol","Body Oil","Bodycare","Luxury Body Oil","Niacinamide","Shimmer Oil","Truly Beauty","Vanilla Baby","Vegan Beauty"],"collections":["Beauty","Skincare","Bodycare"],"descriptionSnippet":"Glow like dessert with Truly Beauty Vanilla Baby Luxury Body Oil, a plumping, satin-finish body oil with pearlescent shimmer and a vanilla-pear-caramel scent.","available":false},{"title":"Truly Beauty Jelly Booster Serum","handle":"truly-beauty-jelly-booster-serum","url":"https://puresupplyshop.com/products/truly-beauty-jelly-booster-serum","productType":"Skin Care","vendor":"Truly Beauty","tags":["Body Serum","Bodycare","Skincare","Truly Beauty","Vegan Beauty"],"collections":["Beauty","Skincare","Bodycare"],"descriptionSnippet":"Truly Beauty Jelly Booster Serum is a jelly-texture body serum that helps hydrate and soften skin while supporting a more even-looking finish.","available":true},{"title":"Truly Beauty Buns of Glowry Tightening Body Serum","handle":"truly-beauty-buns-of-glowry-tightening-body-serum","url":"https://puresupplyshop.com/products/truly-beauty-buns-of-glowry-tightening-body-serum","productType":"","vendor":"Truly Beauty","tags":["Body Serum","Bodycare","Buns of Glowry","Firming Appearance","Truly Beauty","Vegan Beauty","Watermelon","Wheat Protein"],"collections":["Beauty","Skincare","Bodycare"],"descriptionSnippet":"Give your skin a bounce-forward finish with Truly Beauty Buns of Glowry Tightening Body Serum, a lightweight body serum for a smoother, hydrated, firmer-looking appearance.","available":false},{"title":"Truly Beauty Unicorn Fruit Aluminum-Free Deodorant","handle":"truly-beauty-unicorn-fruit-aluminum-free-deodorant","url":"https://puresupplyshop.com/products/truly-beauty-unicorn-fruit-aluminum-free-deodorant","productType":"","vendor":"Truly Beauty","tags":["Aluminum Free","Bodycare","Brightening Appearance","Deodorant","Mandelic Acid","Niacinamide","Truly Beauty","Underarm Care","Unicorn Fruit","Vegan Beauty"],"collections":["Beauty","Bodycare"],"descriptionSnippet":"Stay fresh with Truly Beauty Unicorn Fruit Aluminum-Free Deodorant, designed for odor control with mandelic acid and niacinamide for underarm care.","available":false},{"title":"Malibu C Hard Water Wellness Remedy (12 Packets)","handle":"malibu-c-hard-water-wellness-remedy-12-packets","url":"https://puresupplyshop.com/products/malibu-c-hard-water-wellness-remedy-12-packets","productType":"Hair Care","vendor":"Malibu C","tags":["Haircare"],"collections":["Beauty","Haircare"],"descriptionSnippet":"Malibu C Hard Water Wellness Remedy is a freshly activated crystallized vitamin complex that helps lift mineral deposits from hard or well water.","available":true},{"title":"Malibu C Swimmers Wellness Clarifying Shampoo 9 oz","handle":"malibu-c-swimmers-wellness-clarifying-shampoo-9-oz","url":"https://puresupplyshop.com/products/malibu-c-swimmers-wellness-clarifying-shampoo-9-oz","productType":"Shampoo","vendor":"Malibu C","tags":["Haircare","Malibu C","Shampoo"],"collections":["Beauty","Haircare"],"descriptionSnippet":"Malibu C Swimmers Wellness Clarifying Shampoo is a vegan, sulfate-free clarifying shampoo made to help cleanse pool and swim-day residue from hair.","available":false},{"title":"Malibu C Swimmers Wellness Remedy (12 Packets)","handle":"malibu-c-swimmers-wellness-remedy-12-packets","url":"https://puresupplyshop.com/products/malibu-c-swimmers-wellness-remedy-12-packets","productType":"Hair Care","vendor":"Malibu C","tags":["Haircare"],"collections":["Beauty","Haircare"],"descriptionSnippet":"Malibu C Swimmers Wellness Remedy is a vegan crystallized vitamin treatment that helps neutralize chlorine and remove copper and other pool elements from hair.","available":true},{"title":"Malibu C Un-Do-Goo Clarifying Shampoo 9 oz","handle":"malibu-c-un-do-goo-clarifying-shampoo-9-oz","url":"https://puresupplyshop.com/products/malibu-c-un-do-goo-clarifying-shampoo-9-oz","productType":"Hair Care","vendor":"Malibu C","tags":["Haircare"],"collections":["Beauty","Haircare"],"descriptionSnippet":"Malibu C Un-Do-Goo Clarifying Shampoo is a vegan, sulfate-free clarifier designed to help remove stubborn styling-product resin and buildup.","available":false},{"title":"Malibu C Hard Water Wellness Shampoo","handle":"malibu-c-hard-water-wellness-shampoo-9-oz","url":"https://puresupplyshop.com/products/malibu-c-hard-water-wellness-shampoo-9-oz","productType":"Hair Care","vendor":"Malibu C","tags":["Haircare"],"collections":["Beauty","Haircare"],"descriptionSnippet":"Malibu C Hard Water Wellness Shampoo. 3.4 fl oz size in stock; helps cleanse mineral buildup from hard water.","available":true},{"title":"RAW Liquid Glycerol Unflavored 32 Servings","handle":"raw-liquid-glycerol-unflavored","url":"https://puresupplyshop.com/products/raw-liquid-glycerol-unflavored","productType":"Sports Nutrition","vendor":"RAW Nutrition","tags":["Pre-Workout","RAW","Wellness"],"collections":["Wellness","Pre-Workout Powder"],"descriptionSnippet":"RAW Liquid Glycerol Unflavored is an unflavored liquid glycerol supplement with 32 servings for pre-workout or intra-workout routines.","available":true},{"title":"RAW Essential Charged Pre-Workout Sour Watermelon 25 Servings","handle":"raw-essential-charged-sour-watermelon","url":"https://puresupplyshop.com/products/raw-essential-charged-sour-watermelon","productType":"Sports Nutrition","vendor":"RAW Nutrition","tags":["Pre-Workout","Pre-Workout Powder","RAW","Wellness"],"collections":["Wellness","Pre-Workout Powder"],"descriptionSnippet":"RAW Essential Charged Pre-Workout in Sour Watermelon is a 25-serving pre-workout powder designed to support energy and performance.","available":false},{"title":"RAW EAA+ Essential Amino Acids Pineapple 30 Servings","handle":"raw-eaa-plus-pineapple","url":"https://puresupplyshop.com/products/raw-eaa-plus-pineapple","productType":"Sports Nutrition","vendor":"RAW Nutrition","tags":["Protein","Protein Powders","RAW","Wellness"],"collections":["Wellness","Protein Powders"],"descriptionSnippet":"RAW EAA+ Essential Amino Acids in Pineapple flavor provides 30 servings of essential amino acid powder for recovery and daily protein nutrition around training.","available":false},{"title":"RAW Fuel Carbohydrate Drink Mix Lemon Lime 60 Servings","handle":"raw-fuel-lemon-lime-60-servings","url":"https://puresupplyshop.com/products/raw-fuel-lemon-lime-60-servings","productType":"Sports Nutrition","vendor":"RAW Nutrition","tags":["RAW","Wellness"],"collections":["Wellness"],"descriptionSnippet":"RAW Fuel Lemon Lime is a 60-serving carbohydrate drink mix designed to support endurance sessions and long training blocks.","available":true},{"title":"RAW Replenish Electrolyte Mix Lemon Lime 60 Servings","handle":"raw-replenish-lemon-lime-60-servings","url":"https://puresupplyshop.com/products/raw-replenish-lemon-lime-60-servings","productType":"Sports Nutrition","vendor":"RAW Nutrition","tags":["RAW","Wellness"],"collections":["Wellness"],"descriptionSnippet":"RAW Replenish Lemon Lime is a 60-serving electrolyte formula designed to support hydration around workouts.","available":false},{"title":"RAW Essential Performance Pre-Workout","handle":"raw-essential-performance-pre-workout","url":"https://puresupplyshop.com/products/raw-essential-performance-pre-workout","productType":"Sports Nutrition","vendor":"RAW Nutrition","tags":["Pre-Workout","Pre-Workout Powder","RAW","Wellness"],"collections":["Wellness","Pre-Workout Powder"],"descriptionSnippet":"RAW Essential Performance is a daily pre-workout formula available in Blue Rathberry and Citrus Grapefruit flavors, designed to support training energy and performance.","available":true},{"title":"RAW Pump Non-Stim Pre-Workout","handle":"raw-pump-non-stim-pre-workout","url":"https://puresupplyshop.com/products/raw-pump-non-stim-pre-workout","productType":"Sports Nutrition","vendor":"RAW Nutrition","tags":["Pre-Workout","Pre-Workout Powder","RAW","Wellness"],"collections":["Wellness","Pre-Workout Powder"],"descriptionSnippet":"RAW Pump Non-Stim is a stimulant-free pre-workout designed to support pumps and training feel without caffeine, available in three flavors.","available":true},{"title":"RAW Essential Pre-Workout (30 Servings)","handle":"raw-essential-pre-workout-30-servings","url":"https://puresupplyshop.com/products/raw-essential-pre-workout-30-servings","productType":"Sports Nutrition","vendor":"RAW Nutrition","tags":["Pre-Workout","Pre-Workout Powder","RAW","Wellness"],"collections":["Wellness","Pre-Workout Powder"],"descriptionSnippet":"RAW Essential Pre-Workout is a 30-serving formula designed to support workout energy and focus, available in Blue Raspberry and Sour Watermelon.","available":false},{"title":"RAW Creatine Monohydrate Unflavored","handle":"raw-creatine-monohydrate-unflavored","url":"https://puresupplyshop.com/products/raw-creatine-monohydrate-unflavored","productType":"Sports Nutrition","vendor":"RAW Nutrition","tags":["Creatine","RAW","Wellness"],"collections":["Wellness","Creatine"],"descriptionSnippet":"RAW Creatine Monohydrate Unflavored is available in 30, 50, and 100 serving sizes of unflavored creatine monohydrate powder for training routines.","available":false},{"title":"RAW EAA+ Essential Amino Acids Icy Lemon Slush 30 Servings","handle":"raw-eaa-plus-icy-lemon-slush","url":"https://puresupplyshop.com/products/raw-eaa-plus-icy-lemon-slush","productType":"Sports Nutrition","vendor":"RAW Nutrition","tags":["Protein","Protein Powders","RAW","Wellness"],"collections":["Wellness","Protein Powders"],"descriptionSnippet":"RAW EAA+ Essential Amino Acids in Icy Lemon Slush flavor is a 30-serving powder designed to support recovery and daily protein nutrition around training.","available":true},{"title":"RAW EAA+ Essential Amino Acids 30 Servings","handle":"raw-eaa-plus-essential-amino-acids","url":"https://puresupplyshop.com/products/raw-eaa-plus-essential-amino-acids","productType":"Sports Nutrition","vendor":"RAW Nutrition","tags":["Protein","Protein Powders","RAW","Wellness"],"collections":["Wellness","Protein Powders"],"descriptionSnippet":"RAW EAA+ essential amino acids, 30 servings. Icy Lemon Slush flavor is in stock.","available":true}];

  /* ========== Config / asset resolution ========== */
  function scriptBaseUrl() {
    var cfg = window.ProfessorPureConfig || {};
    if (cfg.assetBase) {
      return String(cfg.assetBase).replace(/\/?$/, '/');
    }
    var scr = document.currentScript;
    if (scr && scr.src) {
      return scr.src.replace(/[^/]+$/, '');
    }
    var scripts = document.getElementsByTagName('script');
    for (var i = scripts.length - 1; i >= 0; i--) {
      var src = scripts[i].src || '';
      if (/professor-pure\.js/i.test(src)) {
        return src.replace(/[^/]+$/, '');
      }
    }
    return '';
  }

  var ASSET_BASE = scriptBaseUrl();
  var AVATAR_URL =
    (window.ProfessorPureConfig && window.ProfessorPureConfig.avatarUrl) ||
    (ASSET_BASE ? ASSET_BASE + 'professor-pure-avatar.png' : '/professor-pure-avatar.png');

  var WELCOME =
    "Hi, I'm Professor Pure. I can help with product questions, ingredients, concerns, and anything order-related.";

  var HANDOFF_LINE =
    'For account security issues, email support@puresupplyshop.com or call +1 (908) 656-5760 (Mon-Fri 10:00 AM - 5:00 PM ET).'

  /* ========== Retrieval (ported from server.js; stock gate ignored) ========== */
  var INTENT_MAP = [
    { triggers: ['dry', 'moisturizer', 'moisturizing', 'skin'], titleTerms: ['moisturizing cream', 'lotion', 'cleanser'], boost: 7 },
    { triggers: ['hair', 'thinning'], titleTerms: ['viviscal', 'hair'], boost: 6 },
    { triggers: ['creatine'], titleTerms: ['creatine'], boost: 8 },
    { triggers: ['workout', 'training', 'gym', 'lift'], titleTerms: ['pre-workout', 'pump', 'glycerol'], boost: 5 },
    { triggers: ['energy'], titleTerms: ['pre-workout', 'pump'], boost: 5 },
    { triggers: ['jittery', 'jitters', 'caffeine', 'stim', 'wired', 'anxious'], titleTerms: ['non-stim', 'pump', 'glycerol'], boost: 10 },
    { triggers: ['pump', 'pumps'], titleTerms: ['pump', 'glycerol'], boost: 8 },
    { triggers: ['shave', 'shaving'], titleTerms: ['shave', 'after shave'], boost: 6 },
    { triggers: ['tea', 'calm', 'relax', 'stress', 'sleep'], titleTerms: ['tea', 'calm'], boost: 5 },
    { triggers: ['magnesium'], titleTerms: ['magnesium'], boost: 7 },
    { triggers: ['electrolyte', 'hydration', 'hydrate'], titleTerms: ['electrolyte', 'replenish'], boost: 6 },
    { triggers: ['amino', 'eaa', 'recovery'], titleTerms: ['eaa', 'amino'], boost: 6 },
    { triggers: ['deodorant'], titleTerms: ['deodorant'], boost: 7 },
    { triggers: ['swimmer', 'swimming', 'chlorine', 'hard', 'water'], titleTerms: ['swimmers', 'hard water', 'malibu'], boost: 6 },
  ];

  var HANDOFF_RE =
    /\b(password|login|log\s*in|hacked|fraud|stolen|chargeback)\b/i;

  function tokenize(text) {
    return String(text || '')
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, ' ')
      .split(/\s+/)
      .filter(function (t) { return t.length > 1; });
  }

  function productText(p) {
    var parts = [
      p.title,
      p.handle,
      p.productType,
      p.vendor,
      p.descriptionSnippet,
      Array.isArray(p.tags) ? p.tags.join(' ') : '',
      Array.isArray(p.collections) ? p.collections.join(' ') : '',
    ];
    return parts.filter(Boolean).join(' ').toLowerCase();
  }

  function intentBoosts(tokens) {
    var tokenSet = {};
    for (var i = 0; i < tokens.length; i++) tokenSet[tokens[i]] = true;
    var out = [];
    for (var j = 0; j < INTENT_MAP.length; j++) {
      var intent = INTENT_MAP[j];
      var hit = false;
      for (var k = 0; k < intent.triggers.length; k++) {
        if (tokenSet[intent.triggers[k]]) { hit = true; break; }
      }
      if (!hit) continue;
      for (var t = 0; t < intent.titleTerms.length; t++) {
        out.push({ term: intent.titleTerms[t], boost: intent.boost });
      }
    }
    return out;
  }


  function rawQueryHasNoStimIntent(text) {
    var t = String(text || '').toLowerCase();
    if (/\b(no|not|dont|don't|without|avoid|hate)\b.{0,24}\b(caffeine|stim|stimulant|jitters?|jittery|wired)\b/.test(t)) return true;
    if (/\b(caffeine|stim|stimulant|jitters?|jittery)\b.{0,16}\b(free|less|no)\b/.test(t)) return true;
    if (/\b(non[-\s]?stim|stim[-\s]?free|caffeine[-\s]?free|no caffeine|decaf)\b/.test(t)) return true;
    if (/\b(dont|don't|do not|didnt|didn't|not)\b.{0,20}\b(jittery|jitters|wired|anxious)\b/.test(t)) return true;
    return false;
  }

  function isStimHeavyProduct(p) {
    var blob = ((p.title || '') + ' ' + (p.handle || '') + ' ' + (p.descriptionSnippet || '') + ' ' + ((p.tags || []).join(' '))).toLowerCase();
    // Non-stim pump / glycerol are NOT stim-heavy
    if (/\bnon[-\s]?stim\b/.test(blob) || /\bpump\b/.test(blob) && /\bnon\b/.test(blob)) return false;
    if (/liquid glycerol|glycerol/.test(blob)) return false;
    if (/essential performance|essential charged|caffeine|stim pre|pre-workout/.test(blob) && !/non[-\s]?stim/.test(blob)) {
      // generic pre-workout without non-stim label counts as stim-heavy
      if (/pump/.test(blob) && /non/.test(blob)) return false;
      if (/essential performance|essential charged|charged/.test(blob)) return true;
      if (/pre-workout|preworkout/.test(blob) && !/non[-\s]?stim/.test(blob) && !/pump/.test(blob)) return true;
    }
    return false;
  }

  function isNonStimTrainingProduct(p) {
    var blob = ((p.title || '') + ' ' + (p.handle || '') + ' ' + ((p.tags || []).join(' '))).toLowerCase();
    if (/non[-\s]?stim/.test(blob)) return true;
    if (/raw pump|pump non-stim|pump non stim/.test(blob)) return true;
    if (/glycerol/.test(blob)) return true;
    return false;
  }

  function scoreProduct(p, tokens, rawQuery) {
    var hay = productText(p);
    var title = String(p.title || '').toLowerCase();
    var score = 0;
    for (var i = 0; i < tokens.length; i++) {
      var tok = tokens[i];
      if (!tok) continue;
      if (hay.indexOf(tok) !== -1) score += 2;
      if (title.indexOf(tok) !== -1) score += 3;
      if (Array.isArray(p.tags)) {
        for (var ti = 0; ti < p.tags.length; ti++) {
          if (String(p.tags[ti]).toLowerCase().indexOf(tok) !== -1) { score += 2; break; }
        }
      }
      if (Array.isArray(p.collections)) {
        for (var ci = 0; ci < p.collections.length; ci++) {
          if (String(p.collections[ci]).toLowerCase().indexOf(tok) !== -1) { score += 1; break; }
        }
      }
    }
    var boosts = intentBoosts(tokens);
    var noStim = rawQueryHasNoStimIntent(rawQuery) || rawQueryHasNoStimIntent(tokens.join(' '));
    for (var b = 0; b < boosts.length; b++) {
      var term = boosts[b].term;
      var boost = boosts[b].boost;
      // If shopper wants no jitters, do not boost generic caffeinated pre-workout matches
      if (noStim && term === 'pre-workout' && isStimHeavyProduct(p)) continue;
      if (title.indexOf(term) !== -1) score += boost;
      else if (hay.indexOf(term) !== -1) score += boost / 2;
    }
    if (noStim) {
      if (isNonStimTrainingProduct(p)) score += 20;
      if (isStimHeavyProduct(p)) score -= 30;
    }
    return score;
  }

  function isRawCreatine(p) {
    return /raw[\s-]*creatine/i.test((p.title || '') + ' ' + (p.handle || ''));
  }

  function applyProductRules(product) {
    if (!isRawCreatine(product)) return product;
    var baseTitle = String(product.title || 'RAW Creatine')
      .replace(/\s*\((?:50|100)\s+servings?\)/ig, '')
      .trim();
    var why =
      'I recommend the RAW Creatine 30 Servings option as a simple starting point for a training routine (SKU 860007286957).';
    return {
      title: /30\s+servings/i.test(baseTitle) ? baseTitle : baseTitle + ' (30 Servings)',
      url: product.url,
      why: why,
      handle: product.handle,
      collections: product.collections || [],
      tags: product.tags || [],
      vendor: product.vendor || '',
      productType: product.productType || '',
    };
  }

  function normalizeProduct(p, score) {
    var title = p.title || 'Product';
    var handle = p.handle || '';
    var url =
      p.url ||
      (handle ? 'https://puresupplyshop.com/products/' + handle : '#');
    var why =
      p.descriptionSnippet ||
      (p.productType
        ? 'Often chosen in our ' + p.productType + ' selection.'
        : 'A Pure Supply Shop option that may fit what you described.');
    return applyProductRules({
      title: title,
      url: url,
      why: String(why).slice(0, 220),
      handle: handle,
      collections: p.collections || [],
      tags: p.tags || [],
      vendor: p.vendor || '',
      productType: p.productType || '',
      _score: score,
    });
  }

  function retrieve(query, limit) {
    limit = limit || 3;
    if (!Array.isArray(PP_CATALOG) || !PP_CATALOG.length) return [];
    var tokens = tokenize(query);
    if (!tokens.length) return [];
    var ranked = [];
    var noStim = rawQueryHasNoStimIntent(query);
    for (var i = 0; i < PP_CATALOG.length; i++) {
      var cand = PP_CATALOG[i];
      if (!cand || cand.available === false) continue; // in-stock only
      // Hard filter: never recommend stim-heavy products when shopper asked for no jitters/caffeine
      if (noStim && isStimHeavyProduct(cand)) continue;
      var sc = scoreProduct(cand, tokens, query);
      if (sc > 0) ranked.push({ p: cand, score: sc });
    }
    ranked.sort(function (a, b) { return b.score - a.score; });
    var selected = ranked.slice(0, limit);
    return selected.map(function (x) {
      return normalizeProduct(x.p, x.score);
    });
  }


  function productLane(p) {
    var cols = (p && p.collections) || [];
    var tags = (p && p.tags) || [];
    var blob = (cols.concat(tags).concat([p.vendor || '', p.productType || '', p.title || ''])).join(' ').toLowerCase();
    // Beauty lane first when clearly beauty/personal care
    if (/(beauty|skincare|skin care|haircare|hair care|bodycare|body care|shave|moisturizer|cleanser|serum|deodorant|sunscreen|vanicream|truly|malibu)/.test(blob)) {
      // Viviscal is hair-health bridge: treat as beauty if hair-focused query later; default health-beauty hybrid -> beauty for category lock with other beauty
      if (/viviscal/.test(blob) && !/(skincare|shave|moisturizer|cleanser|serum)/.test(blob)) return 'health';
      return 'beauty';
    }
    if (/(wellness|sports nutrition|pre-workout|creatine|protein|raw nutrition|glycerol|electrolyte|hume|smart health|fitness)/.test(blob)) {
      return 'wellness';
    }
    if (/(health|vitamin|supplement|dietary)/.test(blob)) return 'health';
    // fallback by first collection name
    for (var i = 0; i < cols.length; i++) {
      var c = String(cols[i]).toLowerCase();
      if (c === 'beauty' || c === 'skincare' || c === 'haircare' || c === 'bodycare') return 'beauty';
      if (c === 'wellness') return 'wellness';
      if (c === 'health') return 'health';
    }
    return 'general';
  }

  function lanesCompatible(a, b) {
    if (!a || !b || a === 'general' || b === 'general') return true;
    if (a === b) return true;
    // health + wellness can mix; neither mixes with beauty
    if ((a === 'health' && b === 'wellness') || (a === 'wellness' && b === 'health')) return true;
    return false;
  }

  function pickOneCoherent(products) {
    if (!products || !products.length) return [];
    var top = products[0];
    var lane = productLane(top);
    // already single; keep only top if others conflict
    return [top];
  }

  function pickVariant(arr) {
    if (!arr || !arr.length) return '';
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function conversationalReply(message, product) {
    var title = product.title || 'this option';
    var why = product.why || 'it fits what you described for everyday use';
    var openers = [
      'Got it. If I had to start you with one option from our shelf, I would go with **' + title + '**.',
      'Hmm, based on that, my first pick would be **' + title + '**.',
      'Alright. One clear recommendation: **' + title + '**.',
      'Thanks for sharing that. I would begin with **' + title + '**.',
      'Here is where I would start: **' + title + '**.',
    ];
    var middles = [
      why.charAt(0).toUpperCase() + why.slice(1),
      'People often look at it when they want something straightforward for that goal.',
      'It stays in the same category as what you asked about, so we are not mixing random aisles.',
    ];
    // Prefer product-specific why as primary middle when present
    var middle = why ? (why.charAt(0).toUpperCase() + why.slice(1)) : pickVariant(middles);
    var closers = [
      'Want me to suggest a different single option in the same category?',
      'If that is not quite right, tell me what to prioritize next (gentle, fragrance-free, training, daily habit) and I will pick one new match.',
      'Curious how it compares to something else you had in mind? Name it and I will steer to one alternative in the same lane.',
      'Should I stay in this category and offer one backup pick instead?',
    ];
    var soft = pickVariant([
      'Soft note: educational product ideas only, not medical advice.',
      'Quick reminder: I share educational guidance only, not medical advice.',
      '',
    ]);
    var parts = [pickVariant(openers), '', middle, '', pickVariant(closers)];
    if (soft) parts.push('', soft);
    return parts.join('\n');
  }

  function emptyReply(message) {
    return pickVariant([
      "I could not find a strong single match for that yet. Give me a bit more on the goal (for example dry skin, training recovery, or hair support) and I will pick one product.",
      "Nothing jumped out as a clean one-product fit. Try another detail like format or category (beauty vs wellness) and I will recommend one option.",
      "I am not seeing a solid match in the catalog for that wording. Rephrase the everyday goal and I will come back with one recommendation."
    ]);
  }

  function templateReply(message, products) {
    if (!products.length) {
      return {
        reply: emptyReply(message),
        products: [],
      };
    }
    var coherent = pickOneCoherent(products);
    var safeProducts = coherent.map(function (p) { return applyProductRules(p); });
    var product = safeProducts[0];
    var reply = conversationalReply(message, product);
    return {
      reply: reply,
      products: [
        { title: product.title, url: product.url, why: product.why, handle: product.handle },
      ],
    };
  }


  var TRACK_URL = 'https://puresupplyshop.com/pages/contact';
  var ORDERS_URL = 'https://puresupplyshop.com/account';
  var SUPPORT_EMAIL = 'support@puresupplyshop.com';
  var SUPPORT_PHONE = '+1 (908) 656-5760';

  var END_CHAT_RE = /\b(thanks|thank you|thx|ty|bye|goodbye|good bye|that.?s all|thats all|all set|i.?m good|im good|done|no more|nothing else|have a good|see you)\b/i;



  function isGreetingIntent(text) {
    var t = String(text || '').trim();
    // Short hellos / small talk only (not "hello I need shampoo")
    if (t.length > 48) return false;
    return /^(hi|hello|hey|howdy|hiya|yo|sup|good\s*(morning|afternoon|evening)|what'?s\s*up|whats\s*up|hola)[!?.\s]*$/i.test(t);
  }

  function greetingReply(message) {
    return pickVariant([
      "Hey! What can I help you find today? Product questions, ingredients, orders, or a coupon if you need one.",
      "Hi there. Tell me what you are shopping for, or ask about an order. I can also share a coupon if that helps.",
      "Hello! I am here for product picks, order help, or a quick coupon. What do you need?"
    ]);
  }

  function isCouponIntent(text) {
    return /\b(coupon|coupons|promo|discount|code|voucher|deal|%\s*off|percent\s*off|save\s*money|any\s*deals?)\b/i.test(text);
  }

  function couponHelpReply(message) {
    return pickVariant([
      "If you add 2 items to your cart, I can get you 10% off your entire order. My boss already approved it. Use code **PROFESSOR** at checkout.",
      "Yes. Add a second item to your cart and I can get you 10% off the whole order with code **PROFESSOR**. My boss signed off on it.",
      "Shhh… don’t tell my boss too loudly, but he already approved this. Add 2 items to your cart and use code **PROFESSOR** for 10% off your entire order."
    ]);
  }

  function isOrderIntent(text) {
    return /\b(order|orders|shipping|shipped|shipment|tracking|track|return|returns|refund|refunds|exchange|exchanges|cancel|cancellation|where.?is.?my|replacement|rma|authorize)\b/i.test(text);
  }

  function orderHelpReply(message) {
    var t = String(message || '').toLowerCase();
    if (/\b(track|tracking|where.?is|shipped|shipping|shipment|status)\b/.test(t)) {
      return pickVariant([
        'I can help with that. The fastest way to check status is:\n\n1. Use Track Your Order in the site menu, or open your account orders page.\n2. Have your order number and the email used at checkout ready.\n\nContact / help page: ' + TRACK_URL + '\n\nIf you paste your order number here (and the email on the order), I will tell you the exact next step. If tracking still looks stuck, email ' + SUPPORT_EMAIL + ' or call ' + SUPPORT_PHONE + '.',
        'Sure. For live tracking, use Track Your Order or your account page with the checkout email and order number.\n\n' + TRACK_URL + '\n\nSend me the order number if you want me to walk you through what to check next.'
      ]);
    }
    if (/\b(cancel|cancellation)\b/.test(t)) {
      return pickVariant([
        'I can help start a cancellation request. If the order has not shipped yet, support can usually stop it quickly.\n\nPlease reply with:\n1. Order number\n2. Email on the order\n3. Confirm you want a full cancel\n\nI will package that for our support team at ' + SUPPORT_EMAIL + ' (or call ' + SUPPORT_PHONE + ', Mon-Fri 10:00 AM - 5:00 PM ET).',
        'For cancellations, we need the order number and checkout email. Reply with those two details and whether you want the whole order canceled. Then we route it to ' + SUPPORT_EMAIL + ' right away.'
      ]);
    }
    if (/\b(return|returns|rma|refund|exchange|replacement|replace)\b/.test(t)) {
      return pickVariant([
        'I can help with a return authorization or replacement.\n\nReply with:\n1. Order number\n2. Email on the order\n3. Which item(s)\n4. Return, refund, or replacement\n5. Short reason\n\nOnce I have that, we send it to ' + SUPPORT_EMAIL + ' for an RMA / next steps. Phone: ' + SUPPORT_PHONE + ' (Mon-Fri 10:00 AM - 5:00 PM ET).',
        'Happy to help on returns or replacements. Send order number, checkout email, the item, and whether you want a refund or replacement. I will get that to ' + SUPPORT_EMAIL + ' for authorization.'
      ]);
    }
    return pickVariant([
      'I can help with order questions. Are you looking to track a shipment, cancel, start a return, or request a replacement? Tell me which one and include your order number if you have it.\n\nHelp page: ' + TRACK_URL + '\nSupport: ' + SUPPORT_EMAIL + ' · ' + SUPPORT_PHONE,
      'Sure. I can help with order tracking guidance plus cancel / return / replacement intake. Which do you need, and what is the order number?'
    ]);
  }

  function localChat(message) {
    var trimmed = String(message || '').trim();
    if (!trimmed) {
      return { reply: pickVariant(['What can I help with today?', 'Ask me about a product, ingredients, or an order.', 'What should we tackle first?']), products: [] };
    }

    if (isGreetingIntent(trimmed)) {
      return { reply: greetingReply(trimmed), products: [] };
    }

    if (END_CHAT_RE.test(trimmed)) {
      return {
        reply: pickVariant([
          'Glad I could help. Thank you for choosing Pure Supply Shop!',
          'Anytime. Thank you for choosing Pure Supply Shop!',
          'Happy to help. Thank you for choosing Pure Supply Shop!'
        ]),
        products: [],
        endChat: true
      };
    }

    if (HANDOFF_RE.test(trimmed)) {
      return {
        reply: HANDOFF_LINE + '\n\nIf you also need a product recommendation, tell me the goal and I will pick one option.',
        products: [],
        handoff: 'human_support'
      };
    }

    if (isCouponIntent(trimmed)) {
      return { reply: couponHelpReply(trimmed), products: [] };
    }

    if (isOrderIntent(trimmed)) {
      return { reply: orderHelpReply(trimmed), products: [] };
    }

    // Pull a shortlist, lock to the top product's lane, then keep exactly one
    var shortlist = retrieve(trimmed, 8);
    if (!shortlist.length) {
      return { reply: emptyReply(trimmed), products: [] };
    }
    var lane = productLane(shortlist[0]);
    var filtered = [];
    for (var i = 0; i < shortlist.length; i++) {
      if (lanesCompatible(lane, productLane(shortlist[i]))) filtered.push(shortlist[i]);
    }
    if (!filtered.length) filtered = [shortlist[0]];
    return templateReply(trimmed, [filtered[0]]);
  }

  /* ========== UI ========== */
  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderMarkdownish(text) {
    var html = escapeHtml(text);
    html = html.replace(/\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
    html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    html = html.replace(/(^|[^*])\*([^*]+)\*(?!\*)/g, '$1<em>$2</em>');
    html = html.replace(/\n/g, '<br>');
    return html;
  }

  function productCards(products) {
    if (!Array.isArray(products) || !products.length) return '';
    var cards = products
      .map(function (p) {
        var title = escapeHtml(p.title || 'Product');
        var why = escapeHtml(p.why || '');
        var url = escapeHtml(p.url || '#');
        return (
          '<div class="pp-product-card"><h4>' +
          title +
          '</h4><p>' +
          why +
          '</p><a href="' +
          url +
          '" target="_blank" rel="noopener noreferrer">View product</a></div>'
        );
      })
      .join('');
    return '<div class="pp-products">' + cards + '</div>';
  }

  function ensureRoot() {
    var root = document.getElementById('pp-root');
    if (!root) {
      root = document.createElement('div');
      root.id = 'pp-root';
      document.body.appendChild(root);
    }
    return root;
  }

  function boot() {
    var root = ensureRoot();
    if (root.getAttribute('data-pp-ready') === '1') return;
    root.setAttribute('data-pp-ready', '1');

    var state = { open: false, sending: false, history: [] };

    root.innerHTML =
      '<div class="pp-name-card" aria-hidden="true"><span class="pp-name-card-text">Professor Pure</span></div>' +
      '<button type="button" class="pp-launcher" aria-label="Open Professor Pure chat" title="Professor Pure - Online">' +
      '<img class="pp-launcher-avatar" src="' +
      escapeHtml(AVATAR_URL) +
      '" alt="Professor Pure" width="96" height="96" decoding="async" />' +
      '<span class="pp-launcher-online" aria-hidden="true"></span>' +
      '</button>' +
      '<div class="pp-panel" role="dialog" aria-label="Professor Pure chat" aria-hidden="true">' +
      '<div class="pp-header">' +
      '<div class="pp-header-left">' +
      '<div class="pp-avatar" aria-hidden="true" title="Professor Pure - Online">' +
      '<img class="pp-avatar-img" src="' +
      escapeHtml(AVATAR_URL) +
      '" alt="" />' +
      '<span class="pp-avatar-initial">P</span>' +
      '</div>' +
      '<div class="pp-header-text">' +
      '<span class="pp-header-title">Professor Pure</span>' +
      '<span class="pp-header-sub">Your Pure Supply Shop helper</span>' +
      '<div class="pp-online-row" aria-label="Online">' +
      '<span class="pp-online-dot" aria-hidden="true"></span>' +
      '<span class="pp-online-text">Online</span>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '<button type="button" class="pp-close" aria-label="Close chat">&times;</button>' +
      '</div>' +
      '<div class="pp-messages" id="pp-messages"></div>' +
      '<div class="pp-footer">' +
      '<form class="pp-form" id="pp-form">' +
      '<textarea class="pp-input" id="pp-input" rows="1" placeholder="Ask about a product or order..." autocomplete="off"></textarea>' +
      '<button type="submit" class="pp-send" id="pp-send">Send</button>' +
      '</form>' +
      '<p class="pp-disclaimer">Educational product ideas only, not medical advice. Check labels and consult a qualified professional for personal health questions.</p>' +
      '</div>' +
      '</div>';

    var launcher = root.querySelector('.pp-launcher');
    var panel = root.querySelector('.pp-panel');
    var closeBtn = root.querySelector('.pp-close');
    var messagesEl = root.querySelector('#pp-messages');
    var form = root.querySelector('#pp-form');
    var input = root.querySelector('#pp-input');
    var sendBtn = root.querySelector('#pp-send');


    function syncMobileViewport() {
      try {
        var rootEl = document.getElementById('pp-root') || document.documentElement;
        if (!window.visualViewport) {
          rootEl.style.setProperty('--pp-keyboard-inset', '0px');
          return;
        }
        var vv = window.visualViewport;
        // Amount of layout viewport covered below the visible area (approx keyboard)
        var inset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
        rootEl.style.setProperty('--pp-keyboard-inset', inset + 'px');
        // Keep latest messages visible after keyboard resize
        if (state.open && messagesEl) {
          messagesEl.scrollTop = messagesEl.scrollHeight;
        }
      } catch (err) {}
    }

    function setOpen(open, opts) {
      opts = opts || {};
      state.open = open;
      if (open) panel.classList.add('pp-open');
      else panel.classList.remove('pp-open');
      panel.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open) {
        document.body.classList.add('pp-chat-open');
        syncMobileViewport();
        // Hide offer teaser when chat opens
        hideOfferTeaser();
        // v5: skip welcome Hi when offer is pending/triggered for this session
        if (!messagesEl.children.length) {
          if (opts.skipWelcome || offerPendingForOpen()) {
            // offer path injects Shhh separately
          } else {
            appendBot(WELCOME, []);
          }
        }
        // Delay focus slightly so layout settles before keyboard opens
        setTimeout(function () {
          if (opts.focus !== false) {
            try { input.focus(); } catch (e) {}
          }
          syncMobileViewport();
          if (opts.scrollToBottom) {
            if (messagesEl) messagesEl.scrollTop = messagesEl.scrollHeight;
          } else if (opts.keepScroll !== true) {
            if (messagesEl) messagesEl.scrollTop = 0; // show greeting at top when opening
          }
        }, 50);
      } else {
        document.body.classList.remove('pp-chat-open');
        syncMobileViewport();
      }
    }

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', syncMobileViewport);
      window.visualViewport.addEventListener('scroll', syncMobileViewport);
    }
    window.addEventListener('resize', syncMobileViewport);
    input.addEventListener('focus', function () { setTimeout(syncMobileViewport, 100); });
    input.addEventListener('blur', function () { setTimeout(syncMobileViewport, 100); });

    launcher.addEventListener('click', function () {
      if (state.open) setOpen(false);
      else openChatFromUser();
    });
    closeBtn.addEventListener('click', function () { setOpen(false); });

    function appendUser(text) {
      var el = document.createElement('div');
      el.className = 'pp-msg pp-msg-user';
      el.textContent = text;
      messagesEl.appendChild(el);
      messagesEl.scrollTop = messagesEl.scrollHeight;
    }

    function appendBot(reply, products) {
      var el = document.createElement('div');
      el.className = 'pp-msg pp-msg-bot';
      el.innerHTML = renderMarkdownish(reply) + productCards(products);
      messagesEl.appendChild(el);
      messagesEl.scrollTop = messagesEl.scrollHeight;
    }

    function showTyping(show) {
      var t = messagesEl.querySelector('.pp-typing');
      if (show) {
        if (!t) {
          t = document.createElement('div');
          t.className = 'pp-typing';
          t.setAttribute('aria-live', 'polite');
          t.setAttribute('aria-label', 'Professor Pure is typing');
          t.innerHTML =
            '<span class="pp-typing-label">Professor Pure is typing</span>' +
            '<span class="pp-typing-dots" aria-hidden="true"><span></span><span></span><span></span></span>';
          messagesEl.appendChild(t);
        }
      } else if (t) {
        t.remove();
      }
      messagesEl.scrollTop = messagesEl.scrollHeight;
    }

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true }));
      }
    });

    function getSessionId() {
      try {
        var k = 'pss_pp_session';
        var id = sessionStorage.getItem(k);
        if (!id) {
          id = 'pp_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
          sessionStorage.setItem(k, id);
        }
        return id;
      } catch (e) {
        return 'pp_anon';
      }
    }

    function chatApiBase() {
      var cfg = window.ProfessorPureConfig || {};
      var u = cfg.chatApiUrl || cfg.apiUrl || '';
      return String(u || '').replace(/\/?$/, '');
    }

    function llmChat(message) {
      var base = chatApiBase();
      if (!base || typeof fetch !== 'function') {
        return Promise.reject(new Error('no_chat_api'));
      }
      var hist = (state.history || []).slice(-12).map(function (h) {
        return { role: h.role, content: String(h.content || '').slice(0, 2000) };
      });
      var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timer = setTimeout(function () {
        if (controller) controller.abort();
      }, 12000);
      return fetch(base + '/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          sessionId: getSessionId(),
          message: message,
          history: hist,
          pageUrl: typeof location !== 'undefined' ? location.href : ''
        }),
        signal: controller ? controller.signal : undefined
      }).then(function (res) {
        clearTimeout(timer);
        if (!res.ok) throw new Error('chat_http_' + res.status);
        return res.json();
      }).then(function (data) {
        if (!data || typeof data.reply !== 'string') throw new Error('bad_chat_payload');
        return {
          reply: data.reply,
          products: Array.isArray(data.products) ? data.products.slice(0, 1) : [],
          endChat: !!data.endChat
        };
      }).catch(function (err) {
        clearTimeout(timer);
        throw err;
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var message = (input.value || '').trim();
      if (!message || state.sending) return;

      state.sending = true;
      sendBtn.disabled = true;
      input.value = '';
      appendUser(message);
      state.history.push({ role: 'user', content: message });
      showTyping(true);

      // 2-3s typing delay so replies feel considered (not instant)
      var typingMs = 2000 + Math.floor(Math.random() * 1000); // 2000-2999ms
      setTimeout(function () {
        var finish = function (data) {
          showTyping(false);
          appendBot(data.reply || '', data.products || []);
          state.history.push({ role: 'assistant', content: data.reply || '' });
          state.sending = false;
          sendBtn.disabled = false;
          input.focus();
        };
        var failSoft = function () {
          try {
            finish(localChat(message));
          } catch (err2) {
            finish({ reply: 'Something went sideways on my end. Please try again in a moment.', products: [] });
          }
        };

        if (chatApiBase()) {
          llmChat(message).then(finish).catch(function () {
            // Network / API failure: fall back to template localChat
            failSoft();
          });
        } else {
          try {
            finish(localChat(message));
          } catch (err) {
            finish({ reply: 'Something went sideways on my end. Please try again in a moment.', products: [] });
          }
        }
      }, typingMs);
    });

    // Speak as Professor Pure in the existing chat bubble (opens if closed).
    function say(text, opts) {
      opts = opts || {};
      var msg = String(text || '').trim();
      if (!msg) return;
      setOpen(true, { focus: false, keepScroll: true, scrollToBottom: true });
      function deliver() {
        appendBot(msg, []);
        state.history.push({ role: 'assistant', content: msg });
        if (messagesEl) messagesEl.scrollTop = messagesEl.scrollHeight;
      }
      if (opts.typing === false) {
        deliver();
        return;
      }
      showTyping(true);
      var typingMs = typeof opts.typingMs === 'number' ? opts.typingMs : 700;
      setTimeout(function () {
        showTyping(false);
        deliver();
      }, typingMs);
    }

    // PROFESSOR offer v5: preview blurb on first ATC (0->1); no auto-open; Shhh only in chat.
    var OFFER_MSG =
      'Shhh… don’t tell my boss. If you add a second item, I can give you 10% off your entire order. Use my coupon code **PROFESSOR**.';
    var OFFER_TEASER_TEXT = 'Shhh… don’t tell my boss';
    var SS_TRIGGERED = 'pss_pp_offer_triggered';
    var SS_CHAT_SHOWN = 'pss_pp_offer_chat_shown';
    var SS_BLURB_DISMISSED = 'pss_pp_offer_blurb_dismissed';
    // legacy key from v4 auto-open path
    var SS_LEGACY_SEEN = 'pss_professor_offer_seen';

    function ssGet(k) {
      try { return sessionStorage.getItem(k) === '1'; } catch (e) { return false; }
    }
    function ssSet(k) {
      try { sessionStorage.setItem(k, '1'); } catch (e) {}
    }
    function ssClear(k) {
      try { sessionStorage.removeItem(k); } catch (e) {}
    }
    function offerTriggered() {
      return ssGet(SS_TRIGGERED) || ssGet(SS_LEGACY_SEEN);
    }
    function offerChatShown() {
      return ssGet(SS_CHAT_SHOWN);
    }
    function offerBlurbDismissed() {
      return ssGet(SS_BLURB_DISMISSED);
    }
    function offerPendingForOpen() {
      // Only while cart still has exactly 1 item (first ATC). Empty cart = no Shhh.
      return offerTriggered() && !offerChatShown() && liveCartCount === 1;
    }

    var liveCartCount = 0;
    var teaserEl = null;

    function hideOfferTeaser() {
      if (teaserEl && teaserEl.parentNode) teaserEl.parentNode.removeChild(teaserEl);
      teaserEl = null;
    }

    function showOfferTeaser() {
      if (liveCartCount !== 1) return;
      if (offerBlurbDismissed() || offerChatShown()) return;
      if (teaserEl && teaserEl.parentNode) return;
      teaserEl = document.createElement('div');
      teaserEl.className = 'pp-offer-teaser';
      teaserEl.setAttribute('role', 'status');
      teaserEl.innerHTML =
        '<button type="button" class="pp-offer-teaser-body" aria-label="Open Professor Pure offer">' +
        '<span class="pp-offer-teaser-text">' + escapeHtml(OFFER_TEASER_TEXT) + '</span>' +
        '</button>' +
        '<button type="button" class="pp-offer-teaser-close" aria-label="Dismiss offer preview">&times;</button>';
      // Place as sibling before launcher so it sits to the left
      root.insertBefore(teaserEl, launcher);
      teaserEl.querySelector('.pp-offer-teaser-body').addEventListener('click', function () {
        openChatFromUser();
      });
      teaserEl.querySelector('.pp-offer-teaser-close').addEventListener('click', function (e) {
        e.stopPropagation();
        ssSet(SS_BLURB_DISMISSED);
        hideOfferTeaser();
      });
    }

    function injectShhhOnce() {
      if (offerChatShown()) return;
      ssSet(SS_CHAT_SHOWN);
      hideOfferTeaser();
      // Deliver Shhh into chat (do not use say() which always opens + may welcome)
      function deliver() {
        appendBot(OFFER_MSG, []);
        state.history.push({ role: 'assistant', content: OFFER_MSG });
        if (messagesEl) messagesEl.scrollTop = messagesEl.scrollHeight;
      }
      showTyping(true);
      setTimeout(function () {
        showTyping(false);
        deliver();
      }, 700);
    }

    function openChatFromUser() {
      var pending = offerPendingForOpen();
      setOpen(true, { skipWelcome: pending, scrollToBottom: pending, keepScroll: pending });
      if (pending) injectShhhOnce();
    }

    (function wireProfessorCartOffer() {
      var prevCount = null;
      var fired = false;

      function markTriggered() {
        ssSet(SS_TRIGGERED);
        ssSet(SS_LEGACY_SEEN); // keep legacy in sync
      }
      function getCount(cart) {
        if (!cart) return null;
        if (typeof cart.item_count === 'number') return cart.item_count;
        if (typeof cart.itemCount === 'number') return cart.itemCount;
        return null;
      }
      function fireOffer() {
        if (fired || offerTriggered()) {
          // Already triggered this session; ensure blurb if still needed
          if (offerTriggered() && !offerChatShown() && !offerBlurbDismissed()) showOfferTeaser();
          return;
        }
        fired = true;
        markTriggered();
        // v5: do NOT open panel / do NOT call setOpen or say(); show blurb only
        showOfferTeaser();
      }
      function resetOfferOnEmptyCart() {
        // Clear sticky flags AND any Shhh bubble left in the panel so empty cart opens on Hello.
        ssClear(SS_TRIGGERED);
        ssClear(SS_CHAT_SHOWN);
        ssClear(SS_BLURB_DISMISSED);
        ssClear(SS_LEGACY_SEEN);
        fired = false;
        hideOfferTeaser();
        if (messagesEl) messagesEl.innerHTML = '';
        if (state && state.history) state.history = [];
        if (state && state.open) appendBot(WELCOME, []);
      }
      function maybeOffer(cart) {
        var count = getCount(cart);
        if (count === null) return;
        liveCartCount = count;
        // Cart emptied: clear offer session so Shhh does not stick with 0 items
        if (count === 0) {
          resetOfferOnEmptyCart();
        }
        if (prevCount === null) {
          prevCount = count;
          return;
        }
        // Only first ATC: 0 -> 1. Skip if already 2+. Never re-fire later ATCs.
        if (prevCount === 0 && count === 1) fireOffer();
        prevCount = count;
      }
      function refreshCart() {
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(maybeOffer)
          .catch(function () {});
      }

      document.addEventListener('cart:updated', function (event) {
        var cart = event && event.detail && event.detail.cart;
        if (cart) maybeOffer(cart);
      });
      document.addEventListener('product-ajax:added', refreshCart);

      try {
        if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
          FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, function (payload) {
            if (payload && payload.cart) maybeOffer(payload.cart);
          });
        }
      } catch (e) {}

      if (window.fetch) {
        var _fetch = window.fetch;
        window.fetch = function () {
          var args = arguments;
          var input = args[0];
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          var p = _fetch.apply(this, args);
          if (url && /\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url)) {
            p.then(function (res) {
              try {
                var clone = res.clone();
                clone.json().then(function (data) {
                  if (data && typeof data.item_count === 'number') maybeOffer(data);
                  else refreshCart();
                }).catch(function () { refreshCart(); });
              } catch (err) {}
              return res;
            }).catch(function () {});
          }
          return p;
        };
      }

      // Seed previous count; do not fire on page load. Restore blurb if needed.
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          prevCount = getCount(cart);
          if (prevCount === null) prevCount = 0;
          liveCartCount = prevCount;
          if (liveCartCount === 0) {
            resetOfferOnEmptyCart();
          } else if (liveCartCount === 1 && offerTriggered() && !offerChatShown() && !offerBlurbDismissed()) {
            showOfferTeaser();
          }
        })
        .catch(function () {
          prevCount = 0;
          liveCartCount = 0;
          resetOfferOnEmptyCart();
        });
    })();

    // Public API for debugging / theme hooks
    window.ProfessorPure = {
      version: '1.6.2-embed-llm-fallback',
      catalogCount: PP_CATALOG.length,
      open: function () { openChatFromUser(); },
      close: function () { setOpen(false); },
      say: say,
      chat: localChat,
      llmEnabled: function () { return !!(window.ProfessorPureConfig && (window.ProfessorPureConfig.chatApiUrl || window.ProfessorPureConfig.apiUrl)); },
      retrieve: retrieve,
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
